import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { NAV_MODULE_ICON } from '../../constants'
import { SVGIcon } from '..'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import messages from './messages'
import { getVersionIcon } from '../../helpers/utils'

const ButtonReveal = styled.button`
  display: inline-block;
  padding: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
  min-height: var(--button-height);
  line-height: 30px;
  width: 75%;
  margin-top: 15px;
  border: 1px solid var(--clr-accent-to-black);
  border-radius: var(--button-border-radius);
  cursor: pointer;
  background-color: ${props =>
    props.revealed ? 'var(--white)' : 'var(--clr-accent)'};
  color: ${props => (props.revealed ? 'var(--clr-accent)' : 'var(--white)')};
  text-decoration: ${props => (props.revealed ? 'underline' : 'none')};
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;

  a {
    color: var(--grey-3);
    text-decoration: underline;
    cursor: pointer;
  }
  &:hover {
    background-color: var(--black);
    border-color: var(--clr-text);
    a {
      color: var(--white);
    }
  }
`

const ContactOption = ({
  showFootprintForm,
  resetAndClose,
  createUserEvent,
  option,
  language,
  revealOverride
}) => {
  const [hasRevealed, setHasRevealed] = useState(false)
  const [botLocation, setBotLocation] = useState(false)
  const [footprintLocation, setFootprintLocation] = useState(false)
  const [neitherFootprintNorBot, setNeitherFootprintNorBot] = useState(false)

  useEffect(() => {
    if (option.link_location) {
      option.link_location === 'footprint'
        ? setFootprintLocation(true)
        : setFootprintLocation(false)
      option.link_location === 'bot'
        ? setBotLocation(true)
        : setBotLocation(false)
    }
  }, [option.link_location])

  useEffect(() => {
    !footprintLocation && !botLocation
      ? setNeitherFootprintNorBot(true)
      : setNeitherFootprintNorBot(false)
  }, [footprintLocation, botLocation])

  const reveal = () => {
    if (footprintLocation) {
      showFootprintForm(option)
    }
    if (botLocation) {
      resetAndClose()
      window.postMessage({ type: 'dbOpenBot' }, '*')
    }
    createUserEvent({
      category: 'navigation',
      data: {
        link_to: '#contact',
        source: `Contact_${option.button_text.replace(/ /g, '_')}`
      }
    })
    setHasRevealed(true)
  }

  const copyToClipboard = (text, instruction) => {
    window.prompt(instruction, text)
  }

  const translated = messages[language]
  const revealed = hasRevealed || revealOverride

  // Traverse the url location and remove a `presales` query param if `link_location` is set to `support`
  /* eslint-disable indent */
  const linkLocation = option.link_location
    ? option.link_location === 'support'
      ? `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? `:${window.location.port}` : ''
        }/${window.location.search.replace('&presales=1', '')}`
      : option.link_location
    : null

  return (
    <div>
      <ButtonReveal
        aria-label={option.contact_text}
        revealed={revealed}
        onClick={() => {
          !revealed && reveal(linkLocation)
        }}
      >
        {revealed ? (
          neitherFootprintNorBot ? (
            <a href={linkLocation} rel="noopener noreferrer" target="_blank">
              {option.contact_text}
            </a>
          ) : (
            option.contact_text
          )
        ) : (
          option.button_text
        )}
      </ButtonReveal>
      {revealed && (
        <button
          aria-label="Copy"
          title={translated.copy}
          className="btn-copy"
          onClick={() =>
            copyToClipboard(
              neitherFootprintNorBot ? linkLocation : option.contact_text,
              translated.copyinstruction
            )
          }
        >
          <SVGIcon src={getVersionIcon(NAV_MODULE_ICON.copy)} />
        </button>
      )}
    </div>
  )
}

ContactOption.propTypes = {
  showFootprintForm: PropTypes.func,
  resetAndClose: PropTypes.func,
  createUserEvent: PropTypes.func,
  option: PropTypes.object,
  language: PropTypes.string,
  help: PropTypes.bool
}

export default LanguageProvider(ContactOption)



// WEBPACK FOOTER //
// ./src/components/ContactUsModal/ContactOption.js